// Module
var code = "<div class=\"u-sizeFullWidth ui-grid-cell-contents\">\n    <div class=\"u-flex u-flexMiddle u-flexSpaced\">\n        <order-status status=\"row.entity.OrderStatus\"></order-status>\n    </div>\n</div>\n";
// Exports
module.exports = code;